<template>
    <div>{{$t('processingOrderNotice')}}</div>
</template>
<script>
import PaymentService from '@/services/payment.service'

export default {
    name: 'VerifyOrder',
    mounted () {
        this.checkOrder()
    },
    methods: {
        checkOrder () {
            let action = this.$route.query.action
            let orderId = this.$route.query.order_id
            if (action === 'check-order') {
                this.verifyOrder(orderId)
            } else if (action === 'cancel-order') {
                this.cancelOrder(orderId)
            }
        },
        cancelOrder (orderId) {
            this.$appService.toastError(this.$t('transactionFail'))
            let source = this.$route.query.source
            let projectId = this.$route.query.project_id
            PaymentService.cancelAPIPackageOrder(projectId, orderId).then(() => {
            }).finally(() => {
                this.$router.push({
                    path: source
                })
            })
        },
        verifyOrder (orderId) {
            let source = this.$route.query.source
            let projectId = this.$route.query.project_id
            PaymentService.verifyAPIPackageOrder(projectId, orderId).then(() => {
                this.$appService.toastSuccess(this.$t('transactionSuccess'))
            }).catch(() => {
                this.$appService.toastInfo(this.$t('canNotVerifyTransactionStatus'))
            }).finally(() => {
                this.$router.push({
                    path: source
                })
            })
        }
    }
}
</script>
